import { PureComponent } from 'react';
import external from '../external';
import Select from '../components/Select';
import type { FormulaNode, UiFormulaNode } from '../typeDefs';

const formulaSelectList: Array<[string, string]> = ([['', '<none>']] as Array<[string, string]>).concat(
    external.formulaList
        .map((obj): [string, string] => [obj._id, obj.name + ' - v' + obj.version])
        .sort((a, b) => a[1].localeCompare(b[1])),
);

interface RefExpressionProps {
    data: UiFormulaNode;
}

export default class RefExpression extends PureComponent<RefExpressionProps> {
    static getStub(): FormulaNode { return { $op: 'ref', $value: null }; }

    render() {
        const { data: { state, change, $value } } = this.props;

        return <div className='expression-ref'>
            <Select
                value={$value || ''}
                options={formulaSelectList}
                onChange={event => change('$value', event.target.value)}
                title={'Select a global reference'}
                readOnly={state.readOnly}
            />
        </div>;
    }
}
